import { Api } from './fetch';

export class StaffNet {
  static get = () => Api.get<'staff', 'get'>('/staff');
}
